export const TestIds = {
  list: 'ai-filter-chips-list',
  chip: 'ai-filter-chips-chip',
};
